'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.carousel.add', [])
  .controller('CarouselAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/carousel/add/index.js